import { render } from "./FullContentLayout.vue?vue&type=template&id=03dcab48&scoped=true"
const script = {}

import "./FullContentLayout.vue?vue&type=style&index=0&id=03dcab48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dcab48"]])

export default __exports__